import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React from "react";
import { number, string } from "prop-types";
import Styled, { css } from "styled-components";
import { primary, extended, backgrounds } from "@uprise/colors";
var ProgressWrap = Styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: row;\n\twidth: 100%;\n\tborder-radius: ", ";\n\theight: ", ";\n\tbackground-color: ", ";\n"])), function (props) {
  return props.radius;
}, function (props) {
  return props.height;
}, extended.purple.five);
var Progress = Styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tborder-radius: ", ";\n      width: ", ";\n      height: ", ";\n\tbackground-color: ", ";\n\n"])), function (props) {
  return props.radius;
}, function (props) {
  return props.percentage;
}, function (props) {
  return props.height;
}, function (props) {
  return props.backgroundColor;
});
export var ProgressBar = function ProgressBar(_ref) {
  var height = _ref.height,
      className = _ref.className,
      percentage = _ref.percentage,
      radius = _ref.radius;
  return /*#__PURE__*/React.createElement(ProgressWrap, {
    className: className,
    height: height,
    radius: radius
  }, /*#__PURE__*/React.createElement(Progress, {
    "data-testid": "completed-percentage",
    percentage: "".concat(percentage, "%"),
    height: height,
    backgroundColor: primary.purple,
    radius: radius
  }));
}; // array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

ProgressBar.propTypes = {
  percentage: number,
  height: string,
  className: string,
  radius: number
};
ProgressBar.defaultProps = {
  percentage: 0,
  radius: 5,
  height: "10px"
};